var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTags({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.523 5.547-4.32-4.32C7.848.898 7.246.625 6.753.625H2.216c-.766 0-1.34.602-1.34 1.367v4.54c0 .491.246 1.093.574 1.448l4.32 4.32c.41.384.93.575 1.45.575.52 0 1.039-.191 1.422-.574l3.882-3.883a2.03 2.03 0 0 0 0-2.871zm-.93 1.941-3.882 3.883a.727.727 0 0 1-1.012 0l-4.32-4.32c-.082-.11-.192-.383-.192-.52V1.992l.028-.027h4.539c.137 0 .41.11.52.191l4.32 4.32a.727.727 0 0 1 0 1.012zm-7-3.8c0 .382-.3.656-.655.656a.632.632 0 0 1-.657-.657c0-.355.274-.656.656-.656.356 0 .657.301.657.656zm10.063.738L10.937.816c-.246-.246-.656-.246-.93.028-.245.246-.245.656.028.93l3.692 3.581c.464.465.71 1.04.71 1.668 0 .63-.246 1.23-.71 1.668l-3.036 3.09c-.273.246-.273.656 0 .93.11.11.274.164.465.164a.64.64 0 0 0 .465-.191l3.035-3.063a3.575 3.575 0 0 0 1.094-2.598c0-.984-.383-1.886-1.094-2.597z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.3a0e235a6bf6f093362b27acad9a3ab1.svg";
export { ForwardRef as ReactComponent };